import { PAGE_SIZE } from '../const';

interface Config {
  index: number;
  size?: number;
}

export const page = ({ index, size = PAGE_SIZE }: Config) => Math.floor(index / size);
